import React from 'react';
import { Alert, Stack, TextField, Typography } from '@mui/material';
import { normalizarCamposTr } from '../../pages/contratos/utils/camposTrFluxo';

/**
 * Formulário dinâmico de campos do TR (schema vem da Configuração de Fluxo / API).
 * Valores ficam só em memória até o pai salvar via API.
 */
export default function CamposTrDinamicosForm({
  campos = null,
  valores = {},
  onChange,
  disabled = false,
  titulo = 'Campos do Termo de Referência',
}) {
  const schema = normalizarCamposTr(campos);

  const setValor = (chave, value) => {
    onChange?.({ ...(valores || {}), [chave]: value });
  };

  if (!schema.length) {
    return <Alert severity="info">Nenhum campo de TR configurado neste fluxo.</Alert>;
  }

  return (
    <Stack spacing={2}>
      {titulo ? (
        <Typography variant="subtitle2" fontWeight={800} color="primary">
          {titulo}
        </Typography>
      ) : null}
      <Alert severity="info" sx={{ py: 0.5 }}>
        Campos definidos em Configuração de Fluxo. Persistência apenas ao salvar o TR no servidor.
      </Alert>
      {schema.map((campo) => {
        const value = valores?.[campo.chave] ?? '';
        const common = {
          key: campo.id || campo.chave,
          label: campo.label + (campo.obrigatorio ? ' *' : ''),
          fullWidth: true,
          size: 'small',
          disabled,
          value,
          onChange: (e) => setValor(campo.chave, e.target.value),
          required: !!campo.obrigatorio,
        };
        if (campo.tipo === 'textarea') {
          return <TextField {...common} multiline minRows={3} />;
        }
        if (campo.tipo === 'numero') {
          return <TextField {...common} type="number" inputProps={{ step: '0.01' }} />;
        }
        if (campo.tipo === 'data') {
          return <TextField {...common} type="date" InputLabelProps={{ shrink: true }} />;
        }
        return <TextField {...common} />;
      })}
    </Stack>
  );
}
